<template>
<div
  v-if="show"
>
  <div
        v-if="payment.request.description != null"
        class="invoice_description"
        v-html="$rc.htmlLinebreak(payment.request.description)"
        style="line-height: 24px"
      >
      </div>

    <div
        v-if="payment.request.invoice_number != null"
        class="invoice_number"
        style="line-height: 24px"
      >
        Invoice # {{payment.request.invoice_number}}
      </div>

      <div
        class="amount"
        v-if="show_amount"
      >
        {{pretty_print_amount_or_for_message}}  
        <span style="font-size: 12px" v-if="show_currency">{{payment.request.currency}}</span>
      </div>

      <div
        v-if="has_charges_show_as"
        class="invoice_number"
        style="line-height: 24px"
      >
        Charges will appear as "{{charges_show_as}}"
      </div>

      
</div>
</template>

<script>
  export default {
      props: {
        payment: {
          type: Object,
          default: function() { return null; }
        },

        auto_hide_amount: {
          type: Boolean,
          default: function() { return false; }
        },

      },

      computed: {
        pretty_print_amount_or_for_message() {
            if (this.payment.request.for_message != null && this.payment.request.for_message != '')
            {
                return this.payment.request.for_message;
            }

            let ret = this.payment.request.amount_pretty_print_without_currency;
            return ret;
        },

        show_amount()
        {
            if ( this.auto_hide_amount != true ) 
              return true;

            if ( this.payment.request.for_message != null && this.payment.request.for_message.trim() != '') return true;
            
            return this.payment.request.amount != 'USD0.00';
        },

        show_currency() 
        {
           if (this.payment.request.for_message != null && this.payment.request.for_message != '')
              return false;
          
            return true;
        },

        show() {
          if ( this.payment == null ) return false;
          if ( this.payment.state == 'void' ) return false;
          return true;
        },

        has_charges_show_as()
        {
          if ( this.payment == null ) return false;
          return this.payment.request.bill_from.bill_from_charges_show_as != null;
        },

        charges_show_as()
        {
          if ( this.payment == null ) return '';
          return this.payment.request.bill_from.bill_from_charges_show_as;
        }
      },
  }
</script>

<style lang="scss" scoped>
.invoice_number,
.invoice_description
{
  text-align: center;
  margin-top: 15px;
  margin-bottom: 15px;
}

.amount
{
  text-align: center;
  font-size: 48px;
  font-weight: bold;
  margin-top: 15px;
  margin-bottom: 15px;
}
</style>